import { useState } from 'react'
import { useGroupsDetailed } from '../groupsDetailedContext'
import { SpaceLoader } from '../../../../../loaders/spaceLoader'
import { formatMoney } from '../../../../../../Utils/formatMoney'
import { FormatMoney } from '../../../formatMoney'
import { TiPlus, TiMinus, TiEquals } from 'react-icons/ti'
import { FiMoreVertical } from 'react-icons/fi'
import { download_csv } from '../../JsonToCsv'
import { PDFGenerator } from '../../PDFGenerator'
import { ExportFiles } from '../../ExportFiles'

import { Container, Header, Table, TableLine, TotalValue, ContainerLoading } from './style'


export function GroupsIncome() {
    const { 
        isLoading, 
        allGroupsDatas, 
        dateToDownload
    } = useGroupsDetailed()
    
    const [isOpenExportFiles, setIsOpenExportFiles] = useState(false);
    
    function handleDownloadCSV() {
        let newArray = []

        allGroupsDatas.groups.map(group => (
            newArray.push({...group, total: group.total.toLocaleString('pt-BR')})
        ))

        const arr = newArray.map((data) => {
            return{
                Codigo: data.id,
                Grupo: data.name,
                Total: data.total
            }
        })

        download_csv(arr, dateToDownload)
    }
    
    function handleDownloadPDF() {
        const bodyContent = {
            tableHeader: [
                {text: "Descrição", style: "header"},
                {text: "Valor", style: "header"},
            ],
            lines: [], 
            widths: ['*', '*']
        }
        
        for (let [index, group] of allGroupsDatas.groups.entries()) {
            const rows = []
            const isEven = index % 2 === 0

            rows.push({
                text: group.name, 
                style: `${isEven ? "line" : "lineGray"}`
            })
            rows.push({
                text: formatMoney(group.total), 
                style: `${isEven ? "line" : "lineGray"}`
            })

            bodyContent.lines.push(rows)
        }

        bodyContent.lines.push([
            { text: 'TOTAL', style: 'total' },
            { 
                text: formatMoney(allGroupsDatas.total), 
                style: 'total' 
            }
        ])
       
        PDFGenerator(dateToDownload, bodyContent)
    }

    
    if(isLoading){
        return(
            <ContainerLoading>

                 <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" />
                 
            </ContainerLoading>
        )  
    }else{
        return(
            <Container>
                <div className="seeMore"> 
                    <FiMoreVertical 
                        onClick={() => setIsOpenExportFiles(true)}
                    />
                   
                   <ExportFiles 
                        handleDownloadCSV={handleDownloadCSV}
                        pdfConverter={handleDownloadPDF}
                        pdfButtonIsVisible={true}
                        isOpen={isOpenExportFiles}
                        setIsOpen={setIsOpenExportFiles}
                   />
                </div>
                
                
                <Header>
                    <strong>Descrição</strong>
                    <strong>Valor</strong>
                </Header>

                <Table>
                    {
                        allGroupsDatas.groups.map(group => (
                            <TableLine key={group.id}>
                                <p>{group.name}</p>
                                <p>
                                    { formatMoney(group.total) }
                                </p>
                            </TableLine>
                        ))
                    }
                </Table>

                <TotalValue>

                    <div className="blue">
                        <span>Grupos</span>
                       
                        <FormatMoney value={allGroupsDatas.valueGroups}/>
                    </div>
                        
                    <TiPlus />

                    <div className="blue">
                        <span>Entrega</span>
                       
                       <FormatMoney value={allGroupsDatas.feeDelivery}/>
                    </div>
                        
                    <TiMinus />

                    <div className="red">
                        <span>Desconto</span>
                       
                        <FormatMoney value={allGroupsDatas.discount}/>
                    </div>
                        
                    <TiEquals />

                    <div className="green">
                        <span>Total</span>
                       
                        <FormatMoney value={allGroupsDatas.total}/>
                    </div>

                </TotalValue>

            </Container>
        )
    }
    
}
